import { IconProps } from '../../icons/types';

const FilterIcon = (props: IconProps) => {
  const { width = 20, height = 20, fillColor = 'var(--navi-color-gray-c3)' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.538 3.15025C16.4427 2.95399 16.2988 2.78951 16.1219 2.67483C15.945 2.56014 15.7421 2.49966 15.5353 2.5H4.4641C4.2573 2.49979 4.05441 2.56026 3.87756 2.67481C3.70069 2.78937 3.55664 2.95361 3.4611 3.14964C3.36556 3.34569 3.3222 3.56599 3.33574 3.78656C3.34927 4.00713 3.4192 4.21949 3.53789 4.4005L3.55473 4.426L8.24549 11.0035V16.75C8.24542 16.8858 8.27994 17.019 8.3452 17.1355C8.41046 17.252 8.50413 17.3474 8.61612 17.4114C8.72811 17.4755 8.85427 17.5059 8.9812 17.4993C9.10807 17.4927 9.23093 17.4494 9.3366 17.374L11.4416 15.874C11.5377 15.8055 11.6164 15.7127 11.671 15.6039C11.7254 15.495 11.7539 15.3735 11.7539 15.25V11.0028L16.4615 4.40275C16.5806 4.22163 16.6508 4.00893 16.6643 3.78798C16.6777 3.56704 16.634 3.34639 16.538 3.15025Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default FilterIcon;
